import { Box, IconButton, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { vehicleModelTemplateStyleProps } from "../theme/main";
import { Button } from "./Button";
import { VehicleModelDialog } from "./VehicleModelDialog";
import { circularProgress } from "./FinalizeSharePanel";

export type VehicleModelInfoBox = {
  title: string;
  points: string[];
};

export type VehicleModelData = {
  image: string;
  logo: string;
  name: ReactNode;
  initialFrame: number;
  infoBox: VehicleModelInfoBox;
};

type VehicleModelTemplateProps = {
  models: VehicleModelData[];
  onStartConfigurator: (model: VehicleModelData) => void;
  loading: boolean;
};

export function VehicleModelTemplate({
  models,
  onStartConfigurator,
  loading,
}: VehicleModelTemplateProps) {
  const [selectedModelIndex, setSelectedModelIndex] = useState<number>();
  const [infoModel, setInfoModel] = useState<VehicleModelData>();
  const {
    templateStyle,
    gradiantLayer,
    modelBoxStyle,
    modelSelectedStyle,
    logoContainerStyle,
    logoStyle,
    actionsStyle,
    actionsVisibleStyle,
  } = vehicleModelTemplateStyleProps;

  return (
    <Box sx={templateStyle}>
      {models.map((model, index) => {
        const isSelected = selectedModelIndex === index;
        const image1 = model.image;
        // console.log(image1);
        return (
          <Box
            key={`${model.infoBox.title}-${index}`}
            // onClick={() => setSelectedModelIndex(index)}
            onClick={() => {
              setSelectedModelIndex(index);
              onStartConfigurator(model);
            }}
            sx={[
              modelBoxStyle,
              isSelected && modelSelectedStyle,
              {
                backgroundImage: "url(" + image1 + ")",
              },
            ]}
          >
            {/* <Box
              component="img"
              src={model.image}
              alt={
                typeof model.name === "string"
                  ? model.name
                  : model.infoBox.title
              }
              sx={imageStyle}
            /> */}

            <Box sx={logoContainerStyle}>
              {/* {typeof model.name === "string" ? (
                <Typography sx={nameTextStyle}>{model.name}</Typography>
              ) : (
                model.name
              )} */}
              <img
                src={model.logo}
                alt={model.name?.toString()}
                style={logoStyle}
              ></img>
            </Box>

            <Box
              sx={[actionsStyle, isSelected && actionsVisibleStyle]}
              onClick={(event) => event.stopPropagation()}
            >
              {/* <Button onClick={() => onStartConfigurator(model)}> */}
              {loading ? circularProgress : ""}
              {/* </Button> */}
              {/* <IconButton
                aria-label={`Show ${model.infoBox.title} information`}
                onClick={() => setInfoModel(model)}
                sx={infoButtonStyle}
              >
                i
              </IconButton> */}
            </Box>
          </Box>
        );
      })}
      <Box sx={gradiantLayer}></Box>

      <VehicleModelDialog
        open={Boolean(infoModel)}
        onClose={() => setInfoModel(undefined)}
        infoBox={infoModel?.infoBox}
      />
    </Box>
  );
}
